
export const Endpoints = {
  settings: 'settings',
  loanProducts: 'loan/product/list/10/1',
  uploadImage: 'upload/image',
  flooringDocument: "/flooring/document",
  createLoan: 'create/loan/application',
  updateApplication: 'update/loan/applicant/details',
  applicationInfo: 'loan/application/info/',
  applicationInfoWithoutToken: 'view/loan/application',
  nricverifier: 'verify/application/access/nric',
  signatureverifier: 'sign/application/remotely',
  previewApplication: 'preview/application',
  loanApplicationForm: 'loan/application/form',
  loanTypes: 'settings/loan/criterias',
  updateLoanType: 'update/loan/application',
  completeLoanApplication: "update/loan/application",
  getcartItems: "cart",
  updatecartItems: "cart/items/update",
  clearcartItems: "cart/clear",
  applicationList: 'loan/application/list',
  downloadDocuments: 'download/application/documents/',
  downloadAllApplications: 'download/application/documents/',
  downloadFlooringDocumnets: "flooring/application/downloadZipDocs/"
}

export const APIResult = {
  SUCCESS: true,
  FAILURE: false
}

export const API = {
  BaseUrl: "https://api.ohhto.com/v1/dealer/",
  PdfUrl: "https://api.ohhto.com/v1/",
  webUrl: "https://loan.ohhto.com/",
  EndPoint: Endpoints,
  Result: APIResult
}
export const serverUrl = "https://loan.ohhto.com/dealer/";
export const IMAGE_BASE_URL = 'https://api.ohhto.com/';

// export const API = {
//   BaseUrl: "http://localhost:8000/v1/dealer/",
//   EndPoint: Endpoints,
//   Result: APIResult
// }
// export const serverUrl = "http://localhost:8000/v1/dealer/";
// export const IMAGE_BASE_URL = 'https://api.ohhto.com/';

const CheckPermissions = (array, keyword, getState) => {
  if (getState) {
    return array?.filter((it) => it?.name === keyword).pop();
  } else {
    return array
      ?.filter((item) => item.name === `${keyword}`)
      ?.map((it) => it.view_permission == 1)
      ?.pop();
  }
};

export const HasPermission = (pathname, Permissions, getState) => {
  switch (pathname) {
    case "/loan-products":
      return CheckPermissions(Permissions, "dealer-commision", getState);
    case "/loan-application":
      return CheckPermissions(Permissions, "new-loan-application", getState);
    case "/case-list":
      return CheckPermissions(Permissions, "loan-application-cases", getState);
    case "/case-detail":
      return CheckPermissions(Permissions, "loan-application-cases", getState);
    case "/details-edit":
      return CheckPermissions(Permissions, "loan-application-cases", getState);
    case "/case-summary":
      return CheckPermissions(Permissions, "loan-application-cases", getState);
    case "/view-application":
      return CheckPermissions(Permissions, "loan-application-cases", getState);
    case "/user-roles":
      return CheckPermissions(Permissions, "user-roles", getState);
    case "/user-accounts":
      return CheckPermissions(Permissions, "user-accounts", getState);
    case "/notification/application_updates":
      return CheckPermissions(Permissions, "application-updates", getState);
    case "/notification/flooring_updates":
      return CheckPermissions(Permissions, "flooring-updates", getState);
    default:
      return null;
  }
};
export const CommomPermission = {
  create_permission: 1,
  delete_permission: 1,
  permission: 1,
  update_permission: 1,
  view_permission: 1
}

export const Titles = [
  {
    label: 'Mr',
    value: 'Mr',
  },
  {
    label: 'Mrs',
    value: 'Mrs',
  },
  {
    label: 'Ms',
    value: 'Ms',
  },
  {
    label: 'Dr',
    value: 'Dr',
  },
];

export const Gender = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
  {
    label: 'Others',
    value: 'Others',
  },
]

export const Race = [
  {
    label: 'Chinese',
    value: 'Chinese',
  },
  {
    label: 'Malay',
    value: 'Malay',
  },
  {
    label: 'Indian',
    value: 'Indian',
  },
  {
    label: 'Others',
    value: 'Others',
  },
]
export const FlooringPdfBaseUrl =
  `${API.PdfUrl}agent/flooring/application/AAF/`;
export const FlooringCaseSummaryUrl =
  `${API.PdfUrl}agent/flooring/application/case-summary/`;
export const FlooringSOAUrl =
  `${API.PdfUrl}agent/flooring/application/SOA/`;


export const Marital_Status = [
  {
    label: 'Single',
    value: 'Single',
  },
  {
    label: 'Married',
    value: 'Married',
  },
  {
    label: 'Divorced',
    value: 'Divorced',
  },
  {
    label: 'Widowed',
    value: 'Widowed',
  },
]
export const Residence = [
  {
    label: 'Owned',
    value: 'Owned',
  },
  {
    label: 'Rented',
    value: 'Rented',
  },
  {
    label: 'Leased',
    value: 'Leased',
  },
  {
    label: 'Mortgage',
    value: 'Mortgage',
  },
]

export const Employment_Type = [
  {
    label: 'Employed',
    value: 'Employed',
  },
  {
    label: 'Unemployed',
    value: 'Unemployed',
  },
  {
    label: 'Self-employed',
    value: 'Self-employed',
  },
  {
    label: 'Part-time',
    value: 'Part-time',
  },
]
export const Finance_Type = [
  {
    label: 'Fully Salaried',
    value: 'Fully Salaried',
  },
  {
    label: 'Fully Commissioned',
    value: 'Fully Commissioned',
  },
  {
    label: 'Freelance or Part-time',
    value: 'Freelance or Part-time',
  },
  {
    label: 'Salary w/<=20% commission',
    value: 'Salary w/<=20% commission',
  },
  {
    label: 'Salary w/>=20% commission',
    value: 'Salary w/>=20% commission',
  },
]

export const CustomerIDType = [
  {
    label: 'Singapore NRIC (e.g. S1234567D)',
    value: 'Singapore NRIC (e.g. S1234567D)',
  },
  {
    label: 'Malaysia NRIC (e.g. 200312345678)',
    value: 'Malaysia NRIC (e.g. 200312345678)',
  },
  {
    label: 'Foreign Passport (e.g. 12345678)',
    value: 'Foreign Passport (e.g. 12345678)',
  },
  {
    label: 'Government (e.g. T08GA1234A)',
    value: 'Government (e.g. T08GA1234A)',
  },
  {
    label: 'Statutory Board (e.g. T08GB1234A)',
    value: 'Statutory Board (e.g. T08GB1234A)',
  },
  {
    label: 'Business (e.g. 51234567M)',
    value: 'Business (e.g. 51234567M)',
  },
  {
    label: 'Company (e.g. 198912345K)',
    value: 'Company (e.g. 198912345K)',
  },
  {
    label: 'Club/Association/Organisation (e.g. T08PQ1234A)',
    value: 'Club/Association/Organisation (e.g. T08PQ1234A)',
  },
  {
    label: 'Professional (e.g. T08PQ1234A)',
    value: 'Professional (e.g. T08PQ1234A)',
  },
  {
    label: 'Foreign Company (e.g. T08FC1234A)',
    value: 'Foreign Company (e.g. T08FC1234A)',
  },
  {
    label: 'Limited Liability Partnership (e.g. T08LL1234A)',
    value: 'Limited Liability Partnership (e.g. T08LL1234A)',
  },
  {
    label: 'Limited Partnership (e.g. T08LP1234A)',
    value: 'Limited Partnership (e.g. T08LP1234A)',
  },
  {
    label: 'Foreign Identification Number (e.g. F/G/M1234567N)',
    value: 'Foreign Identification Number (e.g. F/G/M1234567N)',
  },
]
export const COE_Category = [
  {
    label: 'Cars < 1600cc & 130bhp, or 110kW',
    value: 'A - Category',
  },
  {
    label: 'Cars > 1600cc & 130bhp, or 110kW',
    value: 'B - Category',
  },
  {
    label: 'Goods Vehicle & Bus',
    value: 'C - Category',
  },
  {
    label: 'Open',
    value: 'E - Open Category',
  },

]

export const Vehicle_emission_scheme = [
  {
    label: 'Netural: $0',
    value: 'Netural: $0',
  },
  {
    label: 'Rebate: $15,000',
    value: 'Rebate: $15,000',
  },
  {
    label: 'Rebate: $25,000',
    value: 'Rebate: $25,000',
  },
  {
    label: 'Surcharge:  $15,000',
    value: 'Surcharge:  $15,000',
  },
  {
    label: 'Surcharge: $25,000',
    value: 'Surcharge: $25,000',
  },

]

export const nationalityList = [
  { value: 'AD', label: 'Andorran' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'AF', label: 'Afghan' },
  { value: 'AG', label: 'Antiguan' },
  { value: 'AI', label: 'Anguillan' },
  { value: 'AL', label: 'Albanian' },
  { value: 'AM', label: 'Armenian' },
  { value: 'AN', label: 'Netherlands Antilles' },
  { value: 'AO', label: 'Angolan' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AR', label: 'Argentinian' },
  { value: 'AS', label: 'American Samoan' },
  { value: 'AT', label: 'Austrian' },
  { value: 'AU', label: 'Australian' },
  { value: 'AZ', label: 'Azerbaijani' },
  { value: 'BA', label: 'Bosnian' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BD', label: 'Bangladeshi' },
  { value: 'BE', label: 'Belgian' },
  { value: 'BF', label: 'Burkinabe' },
  { value: 'BG', label: 'Bulgarian' },
  { value: 'BH', label: 'Bahraini' },
  { value: 'BI', label: 'Burundian' },
  { value: 'BJ', label: 'Beninese' },
  { value: 'BL', label: 'Belarussian' },
  { value: 'BN', label: 'Bruneian' },
  { value: 'BO', label: 'Bolivian' },
  { value: 'BR', label: 'Brazilian' },
  { value: 'BS', label: 'Bahamian' },
  { value: 'BT', label: 'Bhutanes' },
  { value: 'BU', label: 'Myanmar' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BZ', label: 'Belizean' },
  { value: 'CA', label: 'Canadian' },
  { value: 'CB', label: 'Croatian' },
  { value: 'CD', label: 'Democratic Republic Of The Congo' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'CG', label: 'Congolese' },
  { value: 'CH', label: 'Swiss' },
  { value: 'CI', label: 'Ivory Coast' },
  { value: 'CK', label: 'Cook Islander' },
  { value: 'CL', label: 'Chilean' },
  { value: 'CM', label: 'Cameroonian' },
  { value: 'CN', label: 'Chinese' },
  { value: 'CO', label: 'Colombian' },
  { value: 'CR', label: 'Costa Rican' },
  { value: 'CS', label: 'Czechoslovak' },
  { value: 'CU', label: 'Cuban' },
  { value: 'CV', label: 'Cape Verdean' },
  { value: 'CY', label: 'Cypriot' },
  { value: 'CZ', label: 'Czech' },
  { value: 'DD', label: 'German, East' },
  { value: 'DE', label: 'German, West' },
  { value: 'DG', label: 'German' },
  { value: 'DJ', label: 'Djiboutian' },
  { value: 'DK', label: 'Danish' },
  { value: 'DM', label: 'Dominican' },
  { value: 'DO', label: 'Dominican (Republic)' },
  { value: 'DZ', label: 'Algerian' },
  { value: 'EC', label: 'Ecuadorian' },
  { value: 'EG', label: 'Egyptian' },
  { value: 'EH', label: 'Sahrawi' },
  { value: 'EN', label: 'Estonian' },
  { value: 'ER', label: 'Eritrean' },
  { value: 'ES', label: 'Spanish' },
  { value: 'ET', label: 'Ethiopian' },
  { value: 'FI', label: 'Finnish' },
  { value: 'FJ', label: 'Fijian' },
  { value: 'FR', label: 'French' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GB', label: 'British' },
  { value: 'GC', label: 'British Overseas Territories Citizen' },
  { value: 'GD', label: 'Grenadian' },
  { value: 'GE', label: 'British Overseas Citizen' },
  { value: 'GF', label: 'French Guianese' },
  { value: 'GG', label: 'British National Overseas' },
  { value: 'GH', label: 'Ghanaian' },
  { value: 'GJ', label: 'British Protected Person' },
  { value: 'GM', label: 'Gambian' },
  { value: 'GN', label: 'Guinean' },
  { value: 'GO', label: 'Georgian' },
  { value: 'GP', label: 'Guadeloupian' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'GR', label: 'Greek' },
  { value: 'GT', label: 'Guatemalan' },
  { value: 'GU', label: 'Guamanian' },
  { value: 'GW', label: 'Guinean (Bissau)' },
  { value: 'GY', label: 'Guyanese' },
  { value: 'HK', label: 'Chinese/Hongkong Sar' },
  { value: 'HN', label: 'Honduran' },
  { value: 'HT', label: 'Haitian' },
  { value: 'HU', label: 'Hungarian' },
  { value: 'HV', label: 'Upper Volta' },
  { value: 'ID', label: 'Indonesian' },
  { value: 'IE', label: 'Irish' },
  { value: 'IL', label: 'Israeli' },
  { value: 'IN', label: 'Indian' },
  { value: 'IQ', label: 'Iraqi' },
  { value: 'IR', label: 'Iranian' },
  { value: 'IS', label: 'Icelander' },
  { value: 'IT', label: 'Italian' },
  { value: 'JM', label: 'Jamaican' },
  { value: 'JO', label: 'Jordanian' },
  { value: 'JP', label: 'Japanese' },
  { value: 'KA', label: 'Cambodian' },
  { value: 'KE', label: 'Kenyan' },
  { value: 'KG', label: 'Kirghiz' },
  { value: 'KH', label: 'Kampuchean' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KM', label: 'Comoran' },
  { value: 'KP', label: 'D.P.R. Korean' },
  { value: 'KR', label: 'Korean, South' },
  { value: 'KS', label: 'Kyrghis' },
  { value: 'KV', label: 'Kosovar' },
  { value: 'KW', label: 'Kuwaiti' },
  { value: 'KY', label: 'Kyrgyzstan' },
  { value: 'KZ', label: 'Kazakhstani' },
  { value: 'LA', label: 'Laotian' },
  { value: 'LB', label: 'Lebanese' },
  { value: 'LC', label: 'St. Lucia' },
  { value: 'LH', label: 'Lithuanian' },
  { value: 'LI', label: 'Liechtensteiner' },
  { value: 'LK', label: 'Sri Lankan' },
  { value: 'LR', label: 'Liberian' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LU', label: 'Luxembourger' },
  { value: 'LV', label: 'Latvian' },
  { value: 'LY', label: 'Libyan' },
  { value: 'MA', label: 'Moroccan' },
  { value: 'MB', label: 'Macedonian' },
  { value: 'MC', label: 'Monacan' },
  { value: 'MD', label: 'Moldavian' },
  { value: 'MF', label: 'Micronesian' },
  { value: 'MG', label: 'Madagasy' },
  { value: 'MH', label: 'Marshallese' },
  { value: 'MJ', label: 'Montenegrin' },
  { value: 'ML', label: 'Malian' },
  { value: 'MN', label: 'Mongolian' },
  { value: 'MO', label: 'Chinese/Macao Sar' },
  { value: 'MQ', label: 'Martiniquais' },
  { value: 'MR', label: 'Mauritanean' },
  { value: 'MS', label: 'Montenegrin' },
  { value: 'MT', label: 'Maltese' },
  { value: 'MU', label: 'Mauritian' },
  { value: 'MV', label: 'Maldivian' },
  { value: 'MW', label: 'Malawian' },
  { value: 'MX', label: 'Mexican' },
  { value: 'MY', label: 'Malaysian' },
  { value: 'MZ', label: 'Mozambican' },
  { value: 'NA', label: 'Namibian' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigerian' },
  { value: 'NI', label: 'Nicaraguan' },
  { value: 'NL', label: 'Dutch' },
  { value: 'NO', label: 'Norwegian' },
  { value: 'NP', label: 'Nepalese' },
  { value: 'NR', label: 'Nauruan' },
  { value: 'NT', label: 'Netherlands' },
  { value: 'NU', label: 'Niuean' },
  { value: 'NZ', label: 'New Zealander' },
  { value: 'OM', label: 'Omani' },
  { value: 'PA', label: 'Panamanian' },
  { value: 'PC', label: 'Pacific Island Trust Territory' },
  { value: 'PE', label: 'Peruvian' },
  { value: 'PF', label: 'French Polynesian' },
  { value: 'PG', label: 'Papua New Guinean' },
  { value: 'PH', label: 'Filipino' },
  { value: 'PI', label: 'Pitcairn' },
  { value: 'PK', label: 'Pakistani' },
  { value: 'PL', label: 'Polish' },
  { value: 'PN', label: 'Palestinian' },
  { value: 'PR', label: 'Puerto Rican' },
  { value: 'PT', label: 'Portuguese' },
  { value: 'PW', label: 'Palauan' },
  { value: 'PY', label: 'Paraguayan' },
  { value: 'QA', label: 'Qatari' },
  { value: 'RE', label: 'Reunionese' },
  { value: 'RF', label: 'Russian' },
  { value: 'RO', label: 'Romanian' },
  { value: 'RS', label: 'Serbian' },
  { value: 'RW', label: 'Rwandan' },
  { value: 'SA', label: 'Saudi Arabian' },
  { value: 'SB', label: 'Solomon Islander' },
  { value: 'SC', label: 'Seychellois' },
  { value: 'SD', label: 'Sudanese' },
  { value: 'SE', label: 'Swedish' },
  { value: 'SG', label: 'Singapore Citizen' },
  { value: 'SI', label: 'Slovenian' },
  { value: 'SK', label: 'Slovak' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SM', label: 'Sammarinese' },
  { value: 'SN', label: 'Senegalese' },
  { value: 'SO', label: 'Somali' },
  { value: 'SR', label: 'Surinamer' },
  { value: 'SS', label: 'Stateless' },
  { value: 'ST', label: 'Sao Tomean' },
  { value: 'SU', label: 'Russian' },
  { value: 'SV', label: 'Salvadoran' },
  { value: 'SW', label: 'Kittian & Nevisian' },
  { value: 'SX', label: 'South Sudanese' },
  { value: 'SY', label: 'Syrian' },
  { value: 'SZ', label: 'Swazi' },
  { value: 'TD', label: 'Chadian' },
  { value: 'TE', label: 'Timorense' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'TG', label: 'Togolese' },
  { value: 'TH', label: 'Thai' },
  { value: 'TI', label: 'Tajikistani' },
  { value: 'TJ', label: 'Tadzhik' },
  { value: 'TK', label: 'Tokelauan' },
  { value: 'TM', label: 'Turkmen' },
  { value: 'TN', label: 'Tunisian' },
  { value: 'TO', label: 'Tongan' },
  { value: 'TP', label: 'East Timorese' },
  { value: 'TR', label: 'Turk' },
  { value: 'TT', label: 'Trinidadian & Tobagonian' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'TW', label: 'Taiwanese' },
  { value: 'TZ', label: 'Tanzanian' },
  { value: 'UG', label: 'Ugandan' },
  { value: 'UK', label: 'British Subject' },
  { value: 'UN', label: 'Unknown' },
  { value: 'UR', label: 'Ukrainian' },
  { value: 'US', label: 'American' },
  { value: 'UY', label: 'Uruguayan' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VA', label: 'Vatican City State (Holy See)' },
  { value: 'VC', label: 'St. Vincentian' },
  { value: 'VE', label: 'Venezuelan' },
  { value: 'VN', label: 'Vietnamese' },
  { value: 'VU', label: 'Ni-Vanuatu' },
  { value: 'WA', label: 'Walisian' },
  { value: 'WE', label: 'Western Samoan' },
  { value: 'WF', label: 'Wallisian' },
  { value: 'WI', label: 'Walisian' },
  { value: 'WK', label: 'West Indian' },
  { value: 'WS', label: 'Samoan' },
  { value: 'WT', label: 'Wallisian' },
  { value: 'WY', label: 'Wyoming' },
  { value: 'YE', label: 'Yemeni' },
  { value: 'ZA', label: 'South African' },
  { value: 'ZM', label: 'Zambian' },
  { value: 'ZW', label: 'Zimbabwean' }
];





export const dataURItoBlob = async (url) => {
  return await (await fetch(url)).blob()
}

export const FormatCurrency = (str) => {
  // console.log("str", str);
  if (str !== undefined && str !== null && str !== "") {
    if (str.toString().includes(".")) {
      const temp = str.toString().includes(".")
        ? str.toString().slice(0, str.toString().indexOf("."))
        : str;
      const decimalPart = str.toString().includes(".")
        ? str.toString().slice(str.toString().indexOf(".") + 1, str?.length)
        : "";
      // console.log("FORMAT", temp, decimalPart, decimalPart?.length);
      return temp !== undefined
        ? decimalPart === "00"
          ? temp
          : decimalPart?.length <= 2
            ? decimalPart?.length == 1 ? `${temp}.${decimalPart}0` : `${temp}.${decimalPart}`
            : `${temp}.${decimalPart.slice(0, 2)}`
        : "";
    } else {
      return str;
    }
  } else {
    return "";
  }
};

export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const DownloadDocumentFile = async (url) => {
  fetch(IMAGE_BASE_URL + url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to download: ${response.status} ${response.statusText}`);
      }
      return response.blob();
    })
    .then(blob => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'document';
      a.click();
      URL.revokeObjectURL(url);
    })
    .catch(error => {
      console.error('Error downloading file:', error);
    });
  // const response = await ServerAPI.DownloadFile(url);
  // if (response) {
  //     console.log(response.data);
  // }
}

export const ConvertByteToMb = (fileSize) => {
  const fileSizeBytes = fileSize; // bytes
  let fileSizeMB = Math.round(fileSizeBytes / (1024 ** 2));
  // console.log("fileSizeMB", fileSizeMB)
  return fileSizeMB;
}
